import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { BreadcrumbService } from '@shared/services';
import { BreadcrumbItem } from '../../models/breadcrumb.model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  /** Already filtered, translated and capped by the builder - the template only renders it. */
  readonly breadcrumbs$: Observable<BreadcrumbItem[]>;

  constructor(breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }

  /**
   * Keyed by label, not by identity: the builder returns fresh objects on every rebuild, so
   * without this a late parent id, or a level shifting position after a dedupe, would tear down
   * and re-create every level instead of leaving the unchanged ones alone.
   */
  trackByLevel(index: number, breadcrumb: BreadcrumbItem): string {
    return breadcrumb.label;
  }
}
